var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronRight = function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#092B49",
    clipPath: "url(#icon-chevron-right-clip0_6000_2781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.5A10.5 10.5 0 1 1 23 12a10.51 10.51 0 0 1-10.5 10.5m0-19.5a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#092B49",
    strokeWidth: 0.5,
    d: "m16.52 12.5-5.5 5.5-.77-.77 4.73-4.73-4.73-4.73.77-.77z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevron-right-clip0_6000_2781"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgIconChevronRight;